import { render, staticRenderFns } from "./ClassSetExport.vue?vue&type=template&id=5b5405f2&scoped=true&"
import script from "./ClassSetExport.vue?vue&type=script&lang=js&"
export * from "./ClassSetExport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5405f2",
  null
  
)

export default component.exports